export function stringToTemplateStringsArray(str) {
    return Object.freeze(Object.assign([str], {
        raw: [String.raw({ raw: [str] })],
    }));
}
